import { ThemeColors } from '@theme/foundations/colors';
import { Box, BoxProps } from '@chakra-ui/react';

interface BadgeProps extends BoxProps {
  variant?: 'neutral' | 'success' | 'warning' | 'error';
  attached?: boolean;
}

const BEBadge = ({
  children,
  attached = true,
  variant = 'neutral',
  ...props
}: BadgeProps) => {
  return (
    <Box
      position={attached ? 'absolute' : 'relative'}
      top={attached ? '8px' : 'unset'}
      left={attached ? '8px' : 'unset'}
      py="8px"
      px="16px"
      bgColor={ThemeColors[variant]['500']}
      borderRadius={'full'}
      color={'white'}
      fontSize={'sm'}
      overflow={'hidden'}
      {...props}
    >
      {children}
    </Box>
  );
};

export default BEBadge;
